import Campaign from '@/services/campaign'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const changeStatusCampaign = async (context, payload = { assignor_id: Int32Array, status: Boolean }) => {
  return new Promise(async (resolve, reject) => {
    Campaign.changeStatus(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const changeStatusAproveRejectRequest = async (context, payload) => {
  return new Promise(async (resolve, reject) => {
    Campaign.changeStatusAproveReject(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  changeStatusCampaign,
  changeStatusAproveRejectRequest
}



// WEBPACK FOOTER //
// ./src/features/payer_assignors/store/actions.js